import React, { useContext, useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import $ from "jquery";
import axios from "axios";
import { toast } from "react-toastify";
import _ from "lodash";
import axiosInstance from "../../config/axiosInterceptor";

const AdminVideoBannedUsers = () => {
  const baseUrl = process.env.REACT_APP_BASEURL1;

  const [videoBannedUsers, setVideoBannedUsers] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [page, setPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [count, setCount] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchInput, setSearchInput] = useState("");

  useEffect(() => {
    fetchVideoBannedUsers();
  }, [entriesPerPage]);

  useEffect(() => {
    fetchVideoBannedUsers();
  }, [page]);

  const renderSerialNumber = (index) => {
    return (page - 1) * entriesPerPage + index + 1;
  };

  const fetchVideoBannedUsers = async () => {
    try {
      setVideoBannedUsers([]);
      const data = await axiosInstance.get(
        `${process.env.REACT_APP_BASEURL3}/admin/videoBannedUsers?page=${page}&limit=${entriesPerPage}`
      );

      if (data) {
        setVideoBannedUsers(data.data.users);
        setCount(data.data.count);
      } else {
        console.log("No data received");
      }
    } catch (error) {
      console.log(error.message);
      toast.error("Failed to fetch video banned users");
    }
  };

  const searchVideoBannedUsers = async (searchValue) => {
    try {
      setVideoBannedUsers([]);
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_BASEURL3}/admin/videoBannedUsersSearch`,
        {
          params: {
            searchValue: searchValue,
            page: 1,
            limit: entriesPerPage,
          },
        }
      );

      if (response.data.success) {
        setVideoBannedUsers(response.data.users);
        setCount(response.data.count);
        setPage(1); // Reset to first page for search results
      } else {
        toast.error(response.data.message || "Search failed");
      }
    } catch (error) {
      console.error(error);
      toast.error("Search failed");
    }
  };

  const handleSearchClick = () => {
    if (searchInput.trim() !== "") {
      searchVideoBannedUsers(searchInput.trim());
    } else {
      fetchVideoBannedUsers();
    }
  };

  const handleUnbanUser = async (userId) => {
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_BASEURL3}/admin/videoBanStatus?id=${userId}&status=0`
      );

      if (response.data.success) {
        toast.success("User video unbanned successfully");
        // Refresh the list
        if (searchInput.trim() !== "") {
          searchVideoBannedUsers(searchInput.trim());
        } else {
          fetchVideoBannedUsers();
        }
      } else {
        toast.error(response.data.message || "Failed to unban user");
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to unban user");
    }
  };

  return (
    <>
      <section className="content-header">
        <h1>Video Banned Users</h1>
      </section>
      <section className="content">
        <div className="row">
          <div className="col-xs-12">
            <div className="box">
              <div className="box-body">
                <div className="row " style={{ padding: "16px 0px" }}>
                  <div className="entries-per-page col-md-4 ">
                    <label htmlFor="entries">Entries per page:</label>
                    <select
                      id="entries"
                      value={entriesPerPage}
                      onChange={(e) =>
                        setEntriesPerPage(parseInt(e.target.value))
                      }
                    >
                      <option value="10">10</option>
                      <option value="100">100</option>
                      <option value="500">500</option>
                      <option value="1000">1000</option>
                    </select>
                  </div>
                  <div className="col-md-2"></div>
                  <div className="form-group col-md-4">
                    <label htmlFor="search">Search by Username:</label>
                    <div className="input-group">
                      <input
                        type="text"
                        id="search"
                        className="form-control"
                        value={searchInput}
                        onChange={(e) => setSearchInput(e.target.value)}
                        placeholder="Enter exact username"
                        onKeyPress={(e) => {
                          if (e.key === "Enter") {
                            handleSearchClick();
                          }
                        }}
                      />
                      <span className="input-group-btn">
                        <button
                          className="btn btn-default"
                          type="button"
                          onClick={handleSearchClick}
                        >
                          Go
                        </button>
                      </span>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <label>&nbsp;</label>
                    <button
                      className="btn btn-info form-control"
                      onClick={() => {
                        setSearchInput("");
                        fetchVideoBannedUsers();
                      }}
                    >
                      Clear
                    </button>
                  </div>
                </div>

                <table
                  id="example1"
                  className="table table-bordered table-striped"
                >
                  <thead>
                    <tr>
                      <th>Sr.</th>
                      <th>Username</th>
                      <th>Name</th>
                      <th>Number</th>
                      <th>Picture</th>
                      <th>Banned Date</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody id="ts">
                    {videoBannedUsers.length === 0 ? (
                      <tr>
                        <td colSpan="8" className="text-center">
                          {searchInput ? "No users found" : "Loading..."}
                        </td>
                      </tr>
                    ) : (
                      videoBannedUsers?.map((user, i) => (
                        <tr key={user._id}>
                          <td>{renderSerialNumber(i)}</td>
                          <td>{user.username}</td>
                          <td>{user.name}</td>
                          <td>{user.number}</td>
                          <td>
                            {user.picture ? (
                              <img
                                src={`${baseUrl}${user.picture}`}
                                alt="Profile"
                                style={{
                                  width: "40px",
                                  height: "40px",
                                  borderRadius: "50%",
                                  objectFit: "cover",
                                }}
                              />
                            ) : (
                              <span>No Image</span>
                            )}
                          </td>
                          <td>
                            {new Date(user.createdAt).toLocaleDateString()}
                          </td>
                          <td>
                            <span className={`label label-danger`}>
                              Video Banned
                            </span>
                          </td>
                          <td>
                            <ul className="admin-action btn btn-default">
                              <li className="dropdown">
                                <a
                                  className="dropdown-toggle"
                                  style={{ color: "black" }}
                                  data-toggle="dropdown"
                                  href="#"
                                  aria-expanded="false"
                                >
                                  Action  
                                </a>
                                <ul className="dropdown-menu dropdown-menu-right">
                                  <li role="presentation">
                                    <Link
                                      role="menuitem"
                                      tabIndex={-1}
                                      to={`/admin/ViewUser?id=${user._id}`}
                                    >
                                      View
                                    </Link>
                                  </li>
                                  <li role="presentation">
                                    <a
                                      role="menuitem"
                                      tabIndex={-1}
                                      href="#"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        if (
                                          window.confirm(
                                            "Are you sure you want to unban this user from video uploads?"
                                          )
                                        ) {
                                          handleUnbanUser(user._id);
                                        }
                                      }}
                                      style={{ color: "green" }}
                                    >
                                      Unban Video
                                    </a>
                                  </li>
                                </ul>
                              </li>
                            </ul>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>

                {/* Pagination links */}
                <div>
                  <ul className="pagination">
                    <div>Total Entries : {count}</div>
                    <li>
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setPage((prev) => Math.max(prev - 1, 1));
                        }}
                      >
                        Previous
                      </span>
                    </li>
                    <li>
                      <span>Page {page}</span>
                    </li>
                    <li>
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          if (Math.ceil(count / entriesPerPage) > page)
                            setPage((prev) => prev + 1);
                        }}
                      >
                        Next
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AdminVideoBannedUsers;
